import type { AssessmentQuestion } from '@entities/assessment'

import { AssessmentTopics } from '@entities/assessment'

import imgQuestion1 from '../../../../ui/images/questions/ela/grade-k6/question-1.png'
import imgQuestion5 from '../../../../ui/images/questions/ela/grade-k6/question-5.png'
import imgQuestion11 from '../../../../ui/images/questions/ela/grade-k6/question-11.png'

export const questions: AssessmentQuestion[] = [
  {
    name: 'grade_k6_1',
    title: 'You hear this sentence in a discussion:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '“I understand your point, but I see it differently.”',
    sentence: 'What does the speaker most likely want to do?',
    image: imgQuestion1,
    answers: [
      {
        name: 'grade_k6_1_a',
        text: 'End the conversation.',
      },
      {
        name: 'grade_k6_1_b',
        text: 'Agree completely.',
      },
      {
        name: 'grade_k6_1_c',
        text: 'Share their own opinion respectfully.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k6_2',
    title: 'What is the best response when someone gives you constructive feedback?',
    topic: AssessmentTopics.ListeningAndSpeaking,
    answers: [
      {
        name: 'grade_k6_2_a',
        text: 'Get defensive and argue.',
      },
      {
        name: 'grade_k6_2_b',
        text: 'Listen carefully and consider their suggestions.',
        correct: true,
      },
      {
        name: 'grade_k6_2_c',
        text: 'Ignore what they say.',
      },
    ],
  },
  {
    name: 'grade_k6_3',
    title: 'You hear this direction:',
    topic: AssessmentTopics.ListeningAndSpeaking,
    detail: '“Before beginning the experiment, gather all materials and read the instructions carefully.”',
    sentence: 'What should you do first?',
    answers: [
      {
        name: 'grade_k6_3_a',
        text: 'Start the experiment.',
      },
      {
        name: 'grade_k6_3_b',
        text: 'Ask someone else to read it.',
      },
      {
        name: 'grade_k6_3_c',
        text: 'Get the materials and read the instructions.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k6_4',
    title: 'Read the passage:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'Ella pushed open the heavy wooden door, her heart pounding. The library was silent except for the creak of the floorboards under her feet. She clutched the ancient map in her hand, hoping it would lead her to the hidden book that no one else could find.',
    sentence: 'What is the main idea of the passage?',
    answers: [
      {
        name: 'grade_k6_4_a',
        text: 'Ella dislikes libraries.',
      },
      {
        name: 'grade_k6_4_b',
        text: 'Ella is afraid of being caught.',
      },
      {
        name: 'grade_k6_4_c',
        text: 'Ella is searching for a special book using a map.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k6_5',
    title: 'Read the passage:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'Bees are essential pollinators in many ecosystems. They help plants reproduce by transferring pollen from one flower to another. Without bees, many fruits and vegetables would not grow, which would affect the food supply for both humans and animals.',
    sentence: 'What is the main idea of the passage?',
    image: imgQuestion5,
    answers: [
      {
        name: 'grade_k6_5_a',
        text: 'Bees make honey.',
      },
      {
        name: 'grade_k6_5_b',
        text: 'Bees play an important role in plant reproduction.',
        correct: true,
      },
      {
        name: 'grade_k6_5_c',
        text: 'Bees live in hives and work in groups.',
      },
    ],
  },
  {
    name: 'grade_k6_6',
    title: 'Read the passage:',
    topic: AssessmentTopics.ReadingAndUnderstanding,
    detail: 'Liam watched as his classmates eagerly raised their hands, hoping to be chosen for the science competition. He looked down at his notebook, unsure if he should try. He knew the answers—he just didn’t think he was good enough.',
    sentence: 'What does this passage tell us about Liam?',
    answers: [
      {
        name: 'grade_k6_6_a',
        text: 'He is not interested in science.',
      },
      {
        name: 'grade_k6_6_b',
        text: 'He lacks confidence in himself.',
        correct: true,
      },
      {
        name: 'grade_k6_6_c',
        text: 'He is upset with his classmates.',
      },
    ],
  },
  {
    name: 'grade_k6_7',
    title: 'Which sentence is correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k6_7_a',
        text: 'Running late I forgot my homework at home.',
      },
      {
        name: 'grade_k6_7_b',
        text: 'Running late, I forgot my homework at home.',
        correct: true,
      },
      {
        name: 'grade_k6_7_c',
        text: 'Running late I forgot, my homework at home.',
      },
    ],
  },
  {
    name: 'grade_k6_8',
    title: 'Which sentence uses punctuation correctly?',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k6_8_a',
        text: 'She said “I will come tomorrow”.',
      },
      {
        name: 'grade_k6_8_b',
        text: 'She said, “I will come tomorrow”. ',
      },
      {
        name: 'grade_k6_8_c',
        text: 'She said, “I will come tomorrow.”',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k6_9',
    title: 'Choose the word that best completes the sentence: The movie was very ________, and everyone enjoyed it.',
    topic: AssessmentTopics.Writing,
    answers: [
      {
        name: 'grade_k6_9_a',
        text: 'boring',
      },
      {
        name: 'grade_k6_9_b',
        text: 'confusing',
      },
      {
        name: 'grade_k6_9_c',
        text: 'exciting',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k6_10',
    title: 'Which sentence uses an apostrophe correctly?',
    topic: AssessmentTopics.Language,
    answers: [
      { name: 'grade_k6_10_a',
        text: 'Its a beautiful day outside.',
      },
      { name: 'grade_k6_10_b',
        text: 'Its\' raining cats and dogs.',
      },
      { name: 'grade_k6_10_c',
        text: 'It’s a beautiful day outside.',
        correct: true,
      },
    ],
  },
  {
    name: 'grade_k6_11',
    title: 'Identify the adjective in this sentence: The tall building stood in the city center.',
    topic: AssessmentTopics.Language,
    image: imgQuestion11,
    answers: [
      {
        name: 'grade_k6_11_a',
        text: 'building',
      },
      {
        name: 'grade_k6_11_b',
        text: 'tall',
        correct: true,
      },
      {
        name: 'grade_k6_11_c',
        text: 'city',
      },
    ],
  },
  {
    name: 'grade_k6_12',
    title: 'Which sentence is a complex sentence?',
    topic: AssessmentTopics.Language,
    answers: [
      {
        name: 'grade_k6_12_a',
        text: 'I went to the store and bought some fruit.',
      },
      {
        name: 'grade_k6_12_b',
        text: 'I like ice cream.',
      },
      {
        name: 'grade_k6_12_c',
        text: 'Although it was raining, we went for a walk.',
        correct: true,
      },
    ],
  },
]
